module.exports = __webpack_public_path__ + "img/Weapon_199.61ff9a69.png";